import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "tooltip__body" };
var _hoisted_2 = { class: "text text--sm" };
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { Tooltip } from "./tooltips";
import { offset, shift, size } from "@floating-ui/dom";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        button: { type: Object },
        small: { type: Boolean, default: false },
        top: { type: Boolean, default: false },
    },
    setup: function (__props) {
        var props = __props;
        var tooltipElement = ref();
        var tooltip;
        var options = computed(function () {
            if (props.top) {
                return {
                    placement: 'top',
                    middleware: [
                        shift({ mainAxis: true, padding: 16 }),
                        size(),
                        offset(8),
                    ],
                };
            }
            return {};
        });
        function init() {
            if (props.button && tooltipElement.value) {
                tooltip = new Tooltip(props.button, tooltipElement.value, options.value);
                tooltip.attachClickEvents();
            }
        }
        onMounted(function () {
            if (props.button && tooltipElement.value) {
                init();
            }
            else {
                watch(function () { return props.button && tooltipElement.value; }, function (value, oldValue) {
                    if (value && !oldValue) {
                        init();
                    }
                });
            }
        });
        onUnmounted(function () {
            if (tooltip) {
                tooltip.destroy();
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tooltip", { 'tooltip--sm': __props.small }]),
                role: "tooltip",
                ref_key: "tooltipElement",
                ref: tooltipElement
            }, [
                _cache[0] || (_cache[0] = _createElementVNode("span", {
                    class: "tooltip__arrow",
                    "data-arrow": ""
                }, null, -1 /* CACHED */)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ])
            ], 2 /* CLASS */));
        };
    }
});
